// extracted by mini-css-extract-plugin
module.exports = {"anchor":"_aa5812","root":"_0bdac8","description":"_6e7e4b"};